import { ActionReducerMap } from '@ngrx/store';
import { authReducer } from './auth/auth.reducer';
import { AuthState } from './auth/auth.models';
import { UIState } from './ui/ui.models';
import { uiReducer } from './ui/ui.reducer';
import { HeaderState } from './header/header.models';
import { headerReducer } from './header/header.reducer';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ChargersState } from '../features/chargers/store/charger.models';
import { chargersReducer } from '../features/chargers/store/charger.reducer';
import { OperatorsState } from './operators/operators.models';
import { operatorsReducer } from './operators/operators.reducer';
import { ChargerEffects } from '../features/chargers/store/charger.effects';
import { AuthEffects } from './auth/auth.effects';
import { HeaderEffects } from './header/header.effects';
import { OperatorsEffects } from './operators/operators.effects';
import { UiEffects } from './ui/ui.effects';
import { CurrentChargerState } from '../features/chargers/store/chargerOverviewStore/chargerOverview.models';
import { currentChargerReducer } from '../features/chargers/store/chargerOverviewStore/chargerOverview.reducer';
import { CurrentChargerEffects } from '../features/chargers/store/chargerOverviewStore/chargerOverview.effects';
import { ChargerConfigurationState } from '../features/chargers/store/charger.configuration.store/charger.configuration.store.models';
import { chargerConfigurationReducer } from '../features/chargers/store/charger.configuration.store/charger.configuration.store.reducer';
import { ChargerConfigurationEffects } from '../features/chargers/store/charger.configuration.store/charger.configuration.store.effects';
import { ChargerStatisticsState } from '../features/chargers/store/charger.statistics.store/charger.statistics.models';
import { chargerStatisticsReducer } from '../features/chargers/store/charger.statistics.store/charger.statistics.reducer';
import { ChargerStatisticsEffects } from '../features/chargers/store/charger.statistics.store/charger.statistics.effects';
import { ConnectorsState } from '../features/connectors/store/connector.models';
import { connectorReducer } from '../features/connectors/store/connector.reducer';
import { ConnectorEffects } from '../features/connectors/store/connector.effects';
import { ChargerGroupsState } from '../features/charger-groups/store/charger-group.models';
import { chargerGroupsReducer } from '../features/charger-groups/store/charger-group.reducer';
import { ChargerGroupsEffects } from '../features/charger-groups/store/charger-group.effects';
import { RfidState } from '../features/rfids/store/rfid.models';
import { rfidReducer } from '../features/rfids/store/rfid.reducer';
import { RfidEffects } from '../features/rfids/store/rfid.effects';
import { CdrState } from '../features/cdrs/store/cdr.model';
import { cdrsReducer } from '../features/cdrs/store/cdr.reducer';
import { CdrEffects } from '../features/cdrs/store/cdr.effects';
import { CompanyState } from '../features/settings/store/company.models';
import { companyReducer } from '../features/settings/store/company.reducer';
import { CompanyEffects } from '../features/settings/store/company.effects';
import { LocationState } from '../features/locations/store/location.models';
import { locationsReducer } from '../features/locations/store/location.reducer';
import { LocationEffects } from '../features/locations/store/location.effects';
import { chardiReducer } from '../features/connectors/store/chardi/chardi.reducer';
import { ChardiState } from '../features/connectors/store/chardi/chardi.models';
import { ChardiEffects } from '../features/connectors/store/chardi/chardi.effects';
import { LocationStatisticsState } from '../features/locations/store/statistics/location-stat.models';
import { locationStatisticsReducer } from '../features/locations/store/statistics/location-stat.reducer';
import { LocationStatisticsEffects } from '../features/locations/store/statistics/location-stat.effects';
import { GridOperatorsState } from '../features/grid-operators/store/grid-operator.models';
import { gridOperatorsReducer } from '../features/grid-operators/store/grid-operator.reducer';
import { GridOperatorsEffects } from '../features/grid-operators/store/grid-operator.effects';
import { TariffsState } from '../features/tariffs/store/tariff.models';
import { TariffEffects } from '../features/tariffs/store/tariff.effects';
import { tariffReducer } from '../features/tariffs/store/tariff.reducer';
import { ConfigurationProfileState } from '../features/configuration-profiles/store/config-profile.models';
import { configurationProfileReducer } from '../features/configuration-profiles/store/config-profile.reducer';
import { ConfigurationProfileEffects } from '../features/configuration-profiles/store/config-profile.effects';
import { AlertsState } from '../features/alerts/store/alert.models';
import { alertsReducer } from '../features/alerts/store/alert.reducer';
import { AlertsEffects } from '../features/alerts/store/alert.effects';
import { BillingTransfersState } from '../features/billing/store/billing.transfers.models';
import { billingTransfersReducer } from '../features/billing/store/billing.transfers.reducer';
import { BillingTransfersEffects } from '../features/billing/store/billing.transfers.effects';
import { BillingSuboperatorsState } from '../features/billing/store/billing.suboperators.models';
import { billingSuboperatorsReducer } from '../features/billing/store/billing.suboperators.reducer';
import { BillingSuboperatorsEffects } from '../features/billing/store/billing.suboperators.effects';
import { SmartCarsState } from '../features/smart-cars/store/smart-car.models';
import { smartCarsReducer } from '../features/smart-cars/store/smart-car.reducer';
import { SmartCarsEffects } from '../features/smart-cars/store/smart-car.effects';
// import other feature reducers here...

export interface AppState {
  auth: AuthState,
  ui: UIState,
  header: HeaderState,
  router: RouterReducerState,
  chargers: ChargersState,
  operators: OperatorsState,
  currentCharger: CurrentChargerState,
  chargerConfiguration: ChargerConfigurationState,
  chargerStatistics: ChargerStatisticsState,
  connectors: ConnectorsState,
  chargerGroups: ChargerGroupsState,
  rfid: RfidState,
  company: CompanyState,
  locations: LocationState,
  cdrs: CdrState,
  chardi: ChardiState,
  locationStatistics: LocationStatisticsState,
  gridOperators: GridOperatorsState,
  tariffs: TariffsState,
  configurationProfiles: ConfigurationProfileState;
  alerts: AlertsState;
  billingTransfers: BillingTransfersState;
  billingSuboperators: BillingSuboperatorsState;
  smartCars: SmartCarsState;
  // filters: FiltersState;
  // ui: UIState;
  // etc.
}

export const appReducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  ui: uiReducer,
  header: headerReducer,
  router: routerReducer,
  chargers: chargersReducer,
  operators: operatorsReducer,
  currentCharger : currentChargerReducer,
  chargerConfiguration: chargerConfigurationReducer,
  chargerStatistics: chargerStatisticsReducer,
  connectors: connectorReducer,
  chargerGroups: chargerGroupsReducer,
  rfid: rfidReducer,
  cdrs: cdrsReducer,
  chardi: chardiReducer,
  company: companyReducer,
  locations: locationsReducer,
  locationStatistics: locationStatisticsReducer,
  gridOperators: gridOperatorsReducer,
  tariffs: tariffReducer,
  configurationProfiles: configurationProfileReducer,
  alerts: alertsReducer,
  billingTransfers: billingTransfersReducer,
  billingSuboperators: billingSuboperatorsReducer,
  smartCars: smartCarsReducer,
  // filters: filtersReducer,
  // ui: uiReducer,
};

export const appEffects = [
  AuthEffects,
  UiEffects,
  HeaderEffects,
  ChargerEffects,
  OperatorsEffects,
  CurrentChargerEffects,
  ChargerConfigurationEffects,
  ChargerStatisticsEffects,
  ConnectorEffects,
  ChargerGroupsEffects,
  RfidEffects,
  CdrEffects,
  ChardiEffects,
  CompanyEffects,
  LocationEffects,
  LocationStatisticsEffects,
  GridOperatorsEffects,
  TariffEffects,
  ConfigurationProfileEffects,
  AlertsEffects,
  BillingTransfersEffects,
  BillingSuboperatorsEffects,
  SmartCarsEffects,
];